import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

export const Searcher = ({ onChange, name, nameOfEntity, navigateToCreate }) => {

    const navigate = useNavigate();

    return (
        <>
            <div>
                <input
                    placeholder={t('SEARCH')}
                    type={"text"}
                    name={name}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={onChange}
                />
            </div>

            <div className='text-end mt-3 mb-3'>
                <p style={{
                    fontWeight: '600',
                    fontSize: '16px',
                    lineHeight: '19px',
                    display: 'inline'
                }}
                    className='m-0 me-1 gray-950-color'
                    onClick={() => navigate(`/settings/entityManagment/${navigateToCreate}/create`)}
                    type="button"
                >
                    {`+ ${t('CREATE')} ${nameOfEntity}`}
                </p>
            </div>
        </>
    )
}
